<template>
  <div
    class="block"
    :class="{align: !marks}"
  >
    <el-slider
      class="silder"
      v-model="selfData"
      range
      show-stops
      :min="min"
      :max="max"
      :marks="marks"
      :style="sliderStyle"
      :format-tooltip="(val) => {
        return `${tooltip}：${val}`
      }"
      v-bind="$attrs"
      @change="change"
    >
    </el-slider>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Array]
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 10
    },
    sliderStyle: {
      type: Object
    },
    tooltip: {
      type: String
    },
    marks: {
      type: Object
    }
  },
  data() {
    return {
      selfData: [0, 0]
    }
  },
  methods: {
    change(val) {
      if (val[0] === 0 && val[1] === 0) {
        val = ''
      }
      this.$emit('input', val)
    }
  },
  watch: {
    value: {
      handler(val) {
        if (!val) {
          this.selfData = [0, 0]
        } else {
          this.selfData = val
        }
      },
      deep: true
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.block {
  display: flex;
  justify-content: space-between;
  min-width: 280px;
  min-height: 55px;
  .silder {
    flex: 1;
  }
  .title {
    margin-right: 16px;
    color: #999;
  }
}
.align {
  align-items: center;
}
</style>
